import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogService } from 'aurelia-dialog';
import { StandardService } from 'pages/standard-setup/standards/service';
import { formatTableLink, createButton } from 'resources/utility';

@inject(StandardService, DialogService, EventAggregator)
export class Standard {
    constructor(standardService, dialogService, ea) {
        this.standardService = standardService;
        this.dialogService = dialogService;
        this.ea = ea;

        this.columns = [
            { dataField: 'number', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, route: 'standard-configs', paramsCallback: (options) => ({ id: options.data.id }) }) },
            { caption: 'Actions', cellTemplate: (container, options) => {
                const deleteButton = createButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete });
                deleteButton.style.marginRight = '20px';
                const editButton = createButton({ container, containerOptions: options, style: 'primary', label: 'Edit', action: this.edit });

                const div = document.createElement('div');
                div.appendChild(deleteButton);
                div.appendChild(editButton);
                container.append(div);
            }, allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('standards:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate() {
        this.subscription.dispose();
    }

    delete = (standard) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.standardService.delete(standard.id);
                this.grid.refresh();
                toastr.success('Standard was deleted!');
            }
        });
    };

    add = () => {
        this.dialogService.open({ viewModel: this.standardService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.standardService.editor, model: { id: data.id } });
    };
}